import { useEffect, useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import useCachedCategoriesList from '@src/adapters/hooks/category/useCachedCategoriesList';
import { Autocomplete, TextField } from '@mui/material';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';

interface Props {
  name: string;
  control: Control<any>;
  isRequired?: Boolean;
}

function CategoryAutoComplete({ name, control, isRequired = false }: Props) {
  const [items, setItems] = useState<IdNameDto[]>([]);

  const { getList } = useCachedCategoriesList();

  useEffect(() => {
    getList().then((result) => {
      setItems(result);
    });
  }, [getList]);

  return (
    <Controller
      name="categoryId"
      control={control}
      rules={isRequired ? { required: 'Category is required' } : {}}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          options={items}
          freeSolo={false}
          fullWidth
          getOptionLabel={(option) => option.name}
          value={items.find((opt) => opt.id === value) || null}
          onChange={(_, newValue) => {
            onChange(newValue ? newValue.id : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Category"
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
        />
      )}
    />
  );
}

export default CategoryAutoComplete;
